import { CardTypes } from '@shared';

export interface Banner {
  title: string;
  text: string;
  visibleFor: CardTypes[] | [];
  // Overall visibility of the banner, independent of the card type
  disabled?: boolean;
  dateFrom?: string; // 'DD-MM-YYYY', like '01-12-2024'
  dateTo?: string; // 'DD-MM-YYYY', like '10-12-2024'
}

export const Banners: Banner[] = [
  {
    title: 'Простір експортера',
    text: '<strong>17 лютого в Києві, UNIT.City, </strong>' + 'не пропустіть найбільшу подію про e-commerce-експорт 2026. Встигніть забронювати свій квиток. Деталі за' +
      ' <a href="https://goal-team.com/export-networking-hub?utm_source=banner&utm_medium=business_cabinet&utm_campaign=exporterspace" target="_blank">посиланням</a>',
    visibleFor: [CardTypes.CCARD, CardTypes.ROZNIZA, CardTypes.IDENTIFICATION, CardTypes.CORPORATE],
    dateFrom: '29-01-2026',
    dateTo: '16-02-2026',
  },
  {
    title: 'Оплата відправлень в якості третьої особи',
    text: 'Вказуйте вашу компанію платником за інші відправлення з новим сервісом «Оплата третьою особою». ' +
      'Підключайте через персонального менеджера та користуйтеся. Деталі за' +
      ' <a href="https://novapost.com/uk-ua/financial-services/payment-of-shipments/payment-third-party/" target="_blank">посиланням</a>',
    visibleFor: [CardTypes.CCARD, CardTypes.IDENTIFICATION, CardTypes.CORPORATE],
  },
  {
    title: 'Хочете отримати нових клієнтів та більше замовлень?',
    text: 'Розміщуйте вашу рекламну пропозицію в наших каналах. Деталі за' +
      ' <a href="https://bit.ly/3CcdsNh" target="_blank">посиланням</a>',
    visibleFor: [CardTypes.CCARD, CardTypes.ROZNIZA, CardTypes.IDENTIFICATION, CardTypes.CORPORATE],
  },
  {
    title: '<strong>Реклама інтернет-магазину з гарантією за результат</strong>',
    text: 'Компанія «К2» збільшить продажі вашого магазину або поверне гроші. 7 років на ринку, статус Google Partner, 650+ клієнтів. Деталі за' +
      ' <a href="https://bit.ly/4rukZLE" target="_blank">посиланням</a>',
    visibleFor: [CardTypes.CCARD, CardTypes.ROZNIZA, CardTypes.IDENTIFICATION, CardTypes.CORPORATE],
    dateFrom: '09-02-2026',
    dateTo: '15-02-2026',
  },
  {
    title: 'Хочете продавати більше за конкурентів?',
    text: 'Оновіть списки відділень та поштоматів Нової Пошти, щоб охопити ще більше клієнтів. Не знаєте, як це зробити? Перейдіть за ' +
      '<a href="https://developers.novaposhta.ua/news/schodenne-onovlennya-dovidnika-viddilen-perekonaytes-scho-otrimuyete-aktualni-dani" target="_blank">посиланням</a>' +
      ', і ми вам допоможемо!',
    visibleFor: [CardTypes.CCARD, CardTypes.IDENTIFICATION, CardTypes.CORPORATE],
  },
  {
    title: 'Податковий юрист для бізнесу від AVIRUM LAW GROUP',
    text: `Захистимо ваші права та інтереси в судах та державних органах. Маємо унікальний досвід розв'язання юридичних проблем. Залишайте заявку на консультацію за ` +
      `<a href="https://bit.ly/45R6pEx" target="_blank">посиланням</a>`,
    visibleFor: [CardTypes.CCARD, CardTypes.IDENTIFICATION, CardTypes.CORPORATE],
    dateFrom: '20-08-2025',
    dateTo: '02-09-2025',
  },
  {
    title: 'Подовжуйте термін зберігання посилок',
    text: 'Термін зберігання у відділенні посилок з послугою «Автоматичне повернення відправлень» можна подовжувати. ' +
      'Деталі за' +
      ' <a href="https://novapost.com/uk-ua/additional-services/auto-return" target="_blank">посиланням</a>',
    visibleFor: [CardTypes.CCARD, CardTypes.ROZNIZA, CardTypes.IDENTIFICATION, CardTypes.CORPORATE],
  },
  {
    title: 'Безплатне переадресування посилок по Україні',
    text: 'Змінюйте місце й адресу доставки, поки відправлення ще не прибуло. Деталі' +
      ' <a href="https://novaposhta.ua/pereadresatsiya_im?utm_source=BK&utm_medium=Banner&utm_campaign=Pereadresatsiya" target="_blank">тут</a>',
    visibleFor: [CardTypes.CCARD, CardTypes.ROZNIZA, CardTypes.IDENTIFICATION, CardTypes.CORPORATE],
  },
  {
    title: 'Сheckbox — цифровий касовий апарат для малого бізнесу',
    text: 'Автоматизація чеків, управління товарами, інтеграція із CRM та інтернет-магазином у два кліки. Спробуйте безплатно. Деталі за' +
      ' <a href="https://bit.ly/4mS3Rwz" target="_blank">посиланням</a>',
    visibleFor: [CardTypes.CCARD, CardTypes.ROZNIZA, CardTypes.IDENTIFICATION, CardTypes.CORPORATE],
    dateFrom: '08-10-2025',
    dateTo: '14-10-2025',
  },
  {
    title: 'Послуга «Вантажні перевезення по Україні» – швидка та безпечна доставка ваших вантажів від 10 до 20 тонн окремим авто',
    text: 'Тепер з можливістю оплати готівкою. Деталі за' +
      ' <a href="https://novaposhta.ua/biznes_klientam/vantazhni_perevezennya/?utm_source=2b&utm_medium=referral&utm_campaign=npu_business" target="_blank">посиланням</a>',
    visibleFor: [CardTypes.CCARD, CardTypes.ROZNIZA, CardTypes.IDENTIFICATION, CardTypes.CORPORATE],
  },
  {
    title: 'Міжнародні фрахти для бізнесу',
    text: 'Швидко та безпечно доставимо ваш вантаж між країнами Європи та Україною. Вартість перевезення: від 1€/км. Залиште заявку за' +
      ' <a href="https://docs.google.com/forms/d/e/1FAIpQLSczezftcY9377yTNnfYkqSLpF3btk0yQMom2bm75aXq_d28YQ/viewform?usp=sf_link " target="_blank">посиланням</a>' + ', і ми надамо пропозицію спеціально для вашого бізнесу',
    visibleFor: [CardTypes.CCARD, CardTypes.ROZNIZA, CardTypes.IDENTIFICATION, CardTypes.CORPORATE],
  },
  {
    title: 'Пакуйте у себе, як на відділенні',
    text: 'Якісне пакування за оптовими цінами за' +
      ' <a href="https://shop.novaposhta.ua" target="_blank">посиланням</a>',
    visibleFor: [CardTypes.CCARD, CardTypes.ROZNIZA, CardTypes.IDENTIFICATION, CardTypes.CORPORATE],
  },
  {
    title: 'Хочете масштабувати свій бізнес? Навчайтесь у Школі бізнесу Нова пошта!',
    text: 'Отримайте практичні знання та розробіть план розвитку власного бізнесу. Деталі за' +
      ' <a href="https://novaposhta.education/"' +
      ' target="_blank">посиланням</a>',
    visibleFor: [CardTypes.CCARD, CardTypes.IDENTIFICATION, CardTypes.CORPORATE],
  },
  {
    title: 'Запропонуйте клієнтам Посилку в кредит',
    text: 'Продавайте в кредит будь-які товари з післяплатою, вартістю від 1000 грн. Деталі за' +
      ' <a href="https://novapay.ua/credit" target="_blank">посиланням</a>',
    visibleFor: [CardTypes.ROZNIZA, CardTypes.CCARD],
  },
  {
    title: 'Послуги для вашого бізнесу',
    text: 'Продавайте легко, а про складські операції, подбаємо ми. Цікаві умови?' +
      ' <a href="https://docs.google.com/forms/d/e/1FAIpQLSfTpCdJS9c70flQF4ujfdZw4bw93x_T6RHHlC8_CuN_61X37g/viewform?usp=sf_link"' +
      ' target="_blank">Заповніть анкету</a>',
    visibleFor: [CardTypes.CCARD, CardTypes.IDENTIFICATION, CardTypes.CORPORATE, CardTypes.ROZNIZA],
  },
  {
    title: 'Зауваження та пропозиції',
    text: 'Пропозиції щодо покращення роботи бізнес-кабінету надсилайте на' +
      ' <a href="mailto:support@novaposhta.ua">support@novaposhta.ua</a> або скористайтесь чатом з оператором',
    visibleFor: [CardTypes.ROZNIZA, CardTypes.CCARD, CardTypes.IDENTIFICATION, CardTypes.CORPORATE],
  },
];
